// extracted by mini-css-extract-plugin
export default {"messageHeader":"MessageHeader_messageHeader__yX0pQ","priorityMessage":"MessageHeader_priorityMessage__xbITp","welcomeMessage":"MessageHeader_welcomeMessage__FPOoA"};